$(document).ready(function() {
    if ($(window).width() < 480) {
        $('.product-main-images').slick({
            centerMode: true,
            arrows: false,
            infinite: true,
            dots: false,
            centerPadding: '0px',
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToScroll: 1,
            slidesToShow: 1
        });
    }
});
